import styled from 'styled-components';

const SubFilterWrapper = styled.div`
  padding-left: ${({ isDesktop }) => (isDesktop ? '20px' : '15px')};
`;

export default SubFilterWrapper;
